import script from "./RiskAnalysisPieCharts.vue?vue&type=script&setup=true&lang=js"
export * from "./RiskAnalysisPieCharts.vue?vue&type=script&setup=true&lang=js"

import "./RiskAnalysisPieCharts.vue?vue&type=style&index=0&id=2164fe1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2164fe1e"]])

export default __exports__